module.exports = __webpack_public_path__ + "img/success.4b45a263.png";